<div>
  <input style="width: 100px" matInput [matDatepicker]="picker1" [formControl]="dateFormControl" />
  <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
  <mat-datepicker #picker1></mat-datepicker>
</div>
